import { BASE_ENDPOINT } from "../../../endpoint";

export const updateLoanApplicationService = async (token: string, institutionId: string, loanId: string, payload: any) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/loanmanagement/institution/${institutionId}/loanapplication/${loanId}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: payload
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
